import {PromoType, TrackingAction, TrackingActionType, TrackingFeature, TrackingFeatureLabels, TrackingFeatureStatus, WkTrackingData} from "../types";
import Slide from "./slide"

/*🤫*/
/*🤫*/
export class TrackingService {

    private global: OttoGlobal;

    constructor() {
        /*🤫*/
        this.global = window.o_global
        this.global = window.o_global || {};
        if (!this.global.eventQBus) {
            /*🤫*/
            /*🤫*/
            this.global.eventQBus = {
                emit: () => {
                    if (window.o_global.debug.status().activated) {
                        console.log("Tracking not available.");
                    }
                }
            }
        }
    }

    sendLargeShopPromoInitialViewTrackingEvent(promoType: PromoType, featureOrder: number, featureIndex: number, filledSlots: number, slides: Array<Slide>,
                                               featureLabels: TrackingFeatureLabels, masFeatureTrackingLabels: TrackingFeatureLabels): void {
        if (slides.length === 0) {
            return
        }
        const trackingFeatures = this.createTrackingFeatures(promoType, featureOrder, featureIndex, filledSlots, featureLabels, masFeatureTrackingLabels, slides);
        this.global.eventQBus.emit("tracking.bct.addFeaturesToPageImpression", trackingFeatures);
    }

    sendLargeShoppromoSlideTrackingEvent(promoType: PromoType, featureOrder: number, featureIndex: number, filledSlots: number, slides: Array<Slide>,
                                         featureLabels: TrackingFeatureLabels, masFeatureTrackingLabels: TrackingFeatureLabels, movementType: TrackingActionType) {
        const trackingAction: TrackingAction = {
            name: movementType,
            features: this.createTrackingFeatures(promoType, featureOrder, featureIndex, filledSlots, featureLabels, masFeatureTrackingLabels, slides)
        }
        this.global.eventQBus.emit('tracking.bct.submitAction', {}, trackingAction);

    }

    sendLargeShopPromoClickTrackingEvent(promoType: PromoType, featureOrder: number, featureIndex: number, filledSlots: number, slide: Slide,
                                         featureLabels: TrackingFeatureLabels, masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingAction: TrackingAction = {
            name: "click",
            features: this.createTrackingFeatures(promoType, featureOrder, featureIndex, filledSlots, featureLabels, masFeatureTrackingLabels, [slide], "clicked", "unused")
        }
        const pageCluster = window.o_util.misc.getPagecluster();
        const wkTrackingData: WkTrackingData = this.createWkTrackingData(promoType, pageCluster, slide);

        this.global.eventQBus.emit('tracking.bct.submitMoveAction', wkTrackingData, trackingAction);
        this.global.eventQBus.emit("tracking.bct.trackOnNextPageImpression", {"promo_Click": promoType});
    }

    sendLargeShopPromoLeverTrackingEvent(promoType: PromoType, featureOrder: number, featureIndex: number, filledSlots: number, slide: Slide,
                                         featureLabels: TrackingFeatureLabels, masFeatureTrackingLabels: TrackingFeatureLabels) {
        const trackingAction: TrackingAction = {
            name: "open",
            features: this.createTrackingFeatures(promoType, featureOrder, featureIndex, filledSlots, featureLabels, masFeatureTrackingLabels, [slide], "clicked", "clicked")
        }
        this.global.eventQBus.emit('tracking.bct.submitAction', {}, trackingAction);
    }

    private createTrackingFeatures(promoType: PromoType, featureOrder: number, featureIndex: number, filledSlots: number, featureLabels: TrackingFeatureLabels, masFeatureTrackingLabels: TrackingFeatureLabels, slides: Array<Slide>, status: TrackingFeatureStatus = "loaded", leverStatus: TrackingFeatureStatus = "loaded"): TrackingFeature[] {
        const trackingFeatures = [this.createLargeShopPromoTrackingFeature(promoType, featureOrder, featureIndex, filledSlots, status, featureLabels, masFeatureTrackingLabels)];

        slides
            .filter(slide => !slide.isTracked() || status == "clicked")
            .forEach((slide) => {
                slide.setIsTracked();
                const slideTrackingPayload = this.createLargeShoppromoTileTrackingFeature(promoType, slide.position, featureIndex, status, slide.featureLabels);
                trackingFeatures.push(slideTrackingPayload);
                if (slide.hasLever) {
                    const leverLabel = this.createLeverTagLabel(slideTrackingPayload["id"], leverStatus, slide.position, slide.leverTrackingPayload);
                    if (leverLabel) {
                        trackingFeatures.push(leverLabel);
                    }
                }
            });
        return trackingFeatures;
    }

    private createWkTrackingData(promoType: "ShopPromotionLarge" | "ShopPromotionLargeDynamo", pageCluster: string | null, slide: Slide): WkTrackingData {
        if (promoType === 'ShopPromotionLarge') {
            return {
                "wk.promo_AttributionFeature": promoType + "_" + pageCluster,
                "wk.promo_AttributionSource": "manual",
                "wk.promo_AttributionScore": "ShopPromotionLarge"
            }
        } else {
            /*🤫*/
            return {
                "wk.promo_AttributionFeature": promoType + "_" + pageCluster,
                "wk.promo_AttributionSource": slide.featureLabels["dynamo_Affinity"][0],
                "wk.promo_AttributionScore": slide.featureLabels["dynamo_Score"][0]
            }
        }
    }

    private createLargeShopPromoTrackingFeature(promoType: string, featureOrder: number, featureIndex: number, filledSlots: number, status: TrackingFeatureStatus,
                                                featureLabels: TrackingFeatureLabels, masFeatureTrackingLabels: TrackingFeatureLabels): TrackingFeature {
        const mergedTrackingLabels = {
            ...featureLabels,
            ...masFeatureTrackingLabels
        }
        return {
            id: this.getIdPrefixForPromoType(promoType) + featureIndex,
            name: promoType,
            position: featureOrder,
            status: status,
            labels: mergedTrackingLabels
        }
    }

    private getIdPrefixForPromoType(promoType: string): string {
        if (promoType === "ShopPromotionLarge") {
            /*🤫*/
            return "ft3_splm";
        } else {
            /*🤫*/
            return "ft3_spla";
        }
    }

    private createLargeShoppromoTileTrackingFeature(promoType: string, positionInSlider: number, featureIndex: number, status: TrackingFeatureStatus, labels: TrackingFeatureLabels): TrackingFeature {
        const idPrefix = this.getIdPrefixForPromoType(promoType);
        return {
            id: idPrefix + featureIndex + "_tile" + positionInSlider,
            parentId: idPrefix + featureIndex,
            name: promoType + "-Tile",
            position: positionInSlider,
            status: status,
            labels: labels
        }
    }

    private createLeverTagLabel(parentId: string, status: TrackingFeatureStatus, position: number, trackingFeature?: TrackingFeature): TrackingFeature | null {
        if (!trackingFeature) {
            return null;
        }
        trackingFeature["id"] = parentId + "_b"
        trackingFeature["parentId"] = parentId;
        trackingFeature["status"] = status;
        trackingFeature["position"] = position;
        return trackingFeature;
    }
}